import types from './types';
import actions from './actions';
import { ValueOf } from 'sl-api-connector/types';

const omniSubcategories = (state = [], action: ReturnType<ValueOf<typeof actions>>) => {
  switch (action.type) {
    case types.RECEIVE_ALL_OMNI_SUBCATEGORIES:
      return Object.assign([], action.subcategories);
    default:
      return state;
  }
};

export default omniSubcategories;
